// Import model
import { RoomPhotoFileCondition } from '../models/RoomPhotoFileCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { RoomPhotoFileIndexedFields } from '../models/RoomPhotoFileIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { RoomPhotoFileIndexedFieldsSerializer } from './RoomPhotoFileIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for RoomPhotoFileCondition - handles JSON serialization and deserialization with type validation
 */
export class RoomPhotoFileConditionSerializer {
  /**
   * Deserializes a JSON string into a RoomPhotoFileCondition instance
   */
  static deserialize(json: string): RoomPhotoFileCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a RoomPhotoFileCondition instance
   */
  static fromObject(obj: any): RoomPhotoFileCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to RoomPhotoFileCondition');
    }


    const instance: RoomPhotoFileCondition = {
      fieldName: obj['fieldName'] as RoomPhotoFileIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of RoomPhotoFileCondition instances
   */
  static deserializeArray(json: string): RoomPhotoFileCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a RoomPhotoFileCondition instance to a JSON string
   */
  static serialize(instance: RoomPhotoFileCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a RoomPhotoFileCondition instance to a plain object
   */
  static toObject(instance: RoomPhotoFileCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of RoomPhotoFileCondition instances to a JSON string
   */
  static serializeArray(instances: RoomPhotoFileCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
